import { FetchUtil } from "../util/FetchUtil";
import { IActivityLoadRequest } from "../models/IActivityLoadRequest";
import { IActivityLoadResponse } from "../models/IActivityLoadResponse";
import { IActivityServiceEndpoint } from "../models/IActivityServiceEndpoint";
import { StringUtil } from "../util/StringUtil";

export class ActivityService {
  constructor(private readonly _endpoint: IActivityServiceEndpoint) {
  }

  public async load(req: IActivityLoadRequest): Promise<IActivityLoadResponse> {
    const endpoint = this._endpoint.load;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const pageNumber =
      req && req.page && req.page > 1 ? req.page.toString() : "";

    const page = pageNumber || "1";

    const topicList = (req.topics || [])
      .map(t => "topicIds=" + encodeURIComponent(t))
      .join("&");

    const queryString = req ? [
      pageNumber ? "page=" + encodeURIComponent(pageNumber) : null,
      req.specialty ? "specialtyId=" + encodeURIComponent(req.specialty) : null,
      topicList
    ].filter(Boolean).join("&") : null;

    const query = queryString ? "?" + queryString : null;

    const url =
      (StringUtil.supplant(endpoint.url, { page, query }) || "")
      .replace(/\{(?:query|page)\}/g, "");

    console.log("Activity Service Request - sending: ");
    console.log({ method: endpoint.method, url });

    const result = await FetchUtil
      .sendMessage({ method: endpoint.method, url }, null);

    const response = result as IActivityLoadResponse;
    response.requestId = req.requestId;

    return response;
  }
}
